module.exports = __webpack_public_path__ + "img/rotated-dots.722d0421.svg";